import api from '@/services/api'

export default {
  createAgent(data) {
    return api.post('/customers', {
      ...data,
      isAgent: true,
    });
  },

  getAgent(id) {
    return api.get(`/customers/${id}`);
  },

  getCustomer(id) {
    return api.get(`/customers/${id}`);
  },

  saveCustomer(data) {
    return api.put(`/customers/${data._id}`, data);
  },

  getAgents(page, terms = '') {
    let params = `&page=${page}`;
    if (terms) {
      params += `&terms=${terms}`
    }
    return api.get(`/customers?isAgent=true${params}`);
  },

  getCustomerRequests(page, term) {
    return api.get(`/customers/requests?page=${page}&term=${term}`)
  },

  downloadCustomerRequests(term) {
    return api({
      url: `/customers/requests?download=true&term=${term}`,
      method: 'GET',
      responseType: 'blob',
    })
  },

  confirmRequest(id) {
    return api.put(`/customers/requests/confirm/${id}`)
  },

  rejectRequest(id) {
    return api.put(`/customers/requests/reject/${id}`)
  },

  blockCustomer(id) {
    return api.put(`/customers/requests/block/${id}`)
  },

  unblockCustomer(id) {
    return api.put(`/customers/requests/unblock/${id}`)
  },

  recoverPassword(userId, email) {
    return api.post(`/users/recover-password/${userId}`, { email });
  },
}